<template>
  <div class="picmanger">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt="">
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>工作桌面</el-breadcrumb-item>
          <el-breadcrumb-item>指派给我的邀约</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt="">
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <h4>指派给我的邀约</h4>
        <!-- <p>+新增用户</p> -->
      </div>

      <div class="tablebg"
           v-loading="isRefresh">
        <div style="width:100%;margin:0 auto;">
          <mypicinvitetable :tableData="tableData"></mypicinvitetable>
        </div>

        <div class="pagination">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page.sync="currentPage"
                         :page-size="pageSize"
                         layout="prev, pager, next"
                         :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mypicinvitetable } from '@/components/index'
import { myPictureNeed } from "@/api/pictureNeed";
import { getDate, formatConversion } from "@/plugins/getdate";
export default {
  components: {
    'mypicinvitetable': mypicinvitetable
  },

  data () {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 15,
      tableData: [],
      timeInt: '',
      isRefresh: false
    };
  },
  methods: {

    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.currentPage = val
      let data = { page: (this.currentPage - 1), pageSize: this.pageSize, packageType: "download" }
      // console.log(data)
      this.myPictureNeedAsync(data)
    },


    //刷新表格
    refresh () {

      this.isRefresh = true
      this.handleCurrentChange(this.currentPage);
      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },



    //获取我的邀约列表

    async myPictureNeedAsync (val) {
      this.isRefresh = true
      let { status, data, message, pagination, errors } = await myPictureNeed(val);
      if (status) {
        this.tableData = data
        this.total = pagination.total

        for (let i = 0; i < this.tableData.length; i++) {
          this.tableData[i].createAtMY = formatConversion(this.tableData[i].createAt.toString())
          if (!this.tableData[i].userName) {
            this.tableData[i].userName = "XXX"
          }

        }

        this.isRefresh = false

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false
      }
    }
  },
  created () {
    this.handleCurrentChange(this.currentPage);
    this.timeInt = setInterval(() => {
      this.handleCurrentChange(this.currentPage);
    }, 90000);
    const h = this.$createElement;
    this.$notify({
      title: '友情提醒',
      message: h('strong', { style: '' }, '请在详情页面添加提示"请转到个人图集或图片中心选用图片推送"'),
      duration: 3000
    });
  },
  beforeDestroy () {  // 组件销毁前调用
    clearTimeout(this.timeInt)
  },
  mounted () {

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./mypicinvite.scss";

h4 {
  font-size: 18px;
}
</style>
